import { defineMessages } from 'utils/intl';

export default defineMessages({
  priceFrom: 'Leasing i raty dla firm od {price}',
  availableFrom: 'Leasing i raty dla zamówień powyżej {price}',
  calculator: 'Dopasuj ofertę do swoich potrzeb',
});
